const getFileExtensionFromPath = (path: string) => "." + path.split(".").at(-1);

export default getFileExtensionFromPath;
